export default "__VITE_PUBLIC_ASSET__1305090b__"